'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var adaptersSuperagent = require('@leancloud/adapters-superagent');

var storage = window.localStorage;
var WebSocket = window.WebSocket;
var platformInfo = {
    name: "Browser",
};

Object.defineProperty(exports, 'request', {
    enumerable: true,
    get: function () {
        return adaptersSuperagent.request;
    }
});
Object.defineProperty(exports, 'upload', {
    enumerable: true,
    get: function () {
        return adaptersSuperagent.upload;
    }
});
exports.WebSocket = WebSocket;
exports.platformInfo = platformInfo;
exports.storage = storage;
//# sourceMappingURL=index.cjs.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@leancloud/platform-adapters-browser/lib/index.cjs.js
// module id = 517
// module chunks = 0